"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _styles = require("@material-ui/core/styles");
var _lodash = require("lodash");
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _queryString = _interopRequireDefault(require("query-string"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _teaserItem = _interopRequireDefault(require("../../components/teaser-item"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(4, 0)
  },
  pagination: {
    display: "flex",
    justifyContent: "center"
  }
}));
const LayoutActivityList = _ref => {
  var _queryString$parse$pr, _queryString$parse, _queryString$parse$ta, _queryString$parse2;
  let {
    match,
    location
  } = _ref;
  const {
    lang,
    id = "",
    page = 1
  } = match.params;
  const {
    search
  } = location;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  const [tag] = (0, _react.useState)((_queryString$parse$ta = (_queryString$parse2 = _queryString.default.parse(search)) === null || _queryString$parse2 === void 0 ? void 0 : _queryString$parse2.tag) !== null && _queryString$parse$ta !== void 0 ? _queryString$parse$ta : "");
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.holidayProgram")) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.holidayProgram")
      }
    };
    setPageData(additionalPageData);
  });
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListActivity.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&groups=").concat(id, "&tags=").concat(tag, "&lang=").concat(lang, "&page=").concat(page, "&pageSize=12");
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-activity", id, tag, lang, page, providers], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const handlePaginate = (event, page) => {
    const tagQuery = tag ? "?tag=".concat(tag) : "";
    const providerQuery = providers ? "".concat(tag ? "&" : "?", "providers=").concat(providers) : "";
    const path = "/".concat(lang, "/activities/").concat(id || "all", "/").concat(page).concat(tagQuery).concat(providerQuery);
    history.push(path);
  };
  const {
    entries,
    items
  } = data === null || data === void 0 ? void 0 : data.data;
  let lastDate = null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, entries > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.root,
    container: true,
    spacing: 2
  }, items.map((_ref2, counter) => {
    let {
      id,
      title,
      media,
      pageName,
      date
    } = _ref2;
    const image = (0, _lodash.first)(media);
    let headline = null;
    if (date.from !== lastDate) {
      headline = /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        className: css.headline
      }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
        uppercase: false,
        title: (0, _moment.default)(date.from).format("dddd") + ", " + (0, _moment.default)(date.from).format("D. MMMM YYYY")
      }));
      lastDate = date.from;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: counter
    }, headline, /*#__PURE__*/_react.default.createElement(_teaserItem.default, {
      title: title,
      imageObj: image,
      pageName: "".concat(pageName, "#").concat(date === null || date === void 0 ? void 0 : date.from),
      timeFrom: date === null || date === void 0 ? void 0 : date.timeFrom,
      timeTo: date === null || date === void 0 ? void 0 : date.timeTo
    }));
  })), /*#__PURE__*/_react.default.createElement(_lab.Pagination, {
    className: css.pagination,
    count: Math.ceil(entries / 12),
    color: "primary",
    page: parseInt(page),
    onChange: handlePaginate
  })) : /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    severity: "error"
  }, t("site.ui.errors.noActivitiesFound"))));
};
var _default = exports.default = LayoutActivityList;